export const services = {
  title: "Serviços Adicionais",
  subtitle: "Serviços complementares para facilitar a vida escolar da sua família",
  transport: {
    title: "Táxi desde Vigo",
    description: "Táxi desde Vigo. Mínimo de 4 lugares. É o único serviço com compromisso de reserva de todo o trimestre; o preço indicado é mensal.",
    roundTrip: "Ida e volta",
    roundTripPrice: "225€/mês"
  },
  earlyBirds: {
    title: "Madrugadores",
    schedule: "Serviço diário a partir das 8:15h",
    monthly: "Mensal",
    monthlyPrice: "75€",
    daily: "Dias avulsos",
    dailyPrice: "7€",
    note: "* Preço por família - Segunda a Sexta incluídos"
  },
  lunch: {
    title: "Refeitório",
    description: "Refeição e lanche da manhã seguindo uma dieta equilibrada com produtos ecológicos e locais",
    monthly: "5 dias/semana",
    monthlyPrice: "195€",
    threeDays: "3 dias/semana",
    twoDays: "2 dias/semana",
    perMonth: "/mês",
    note: "Os planos de refeitório são reservados e pagos mensalmente. Escolhe 5, 3 ou 2 dias fixos por semana. Incluem ludoteca até às 17:00 (sexta até às 16:00). Dias avulsos: avisar com 48 horas de antecedência.",
    daily: "Dias avulsos",
    dailyPrice: "15€",
    takeaway: {
      title: "Comida para levar",
      description: "Pelo mesmo preço também pode encomendar a comida para recolher em qualquer momento entre as 14:00h e as 17:00h. A marmita é fornecida pela Gándara."
    }
  },
  ludoteca: {
    title: "Tardes Gándara",
    schedule: "Horário: 14:00h às 17:00h",
    description: "Almoço e ludoteca até às 17:00 (sexta, 16:00), com planos de 5, 3 ou 2 dias por semana",
    freeWith: "Ver as atividades 26-27: horário, atividades e preços",
    options: [
      { label: "Refeitório", price: "14:00 - 15:00" },
      { label: "Ludoteca", price: "15:00 - 17:00 (sexta, 16:00)" }
    ],
    note: "* Informações e reservas por WhatsApp: 616 975 363"
  },
  contact: {
    title: "Interessa-se por algum serviço?",
    description: "Contacte-nos para conhecer mais detalhes e disponibilidade",
    button: "Agendar uma visita"
  }
};
